import { Check } from "lucide-react";
import { Reveal, SectionHeader } from "../site/Reveal";

export default function SplitSection({ overline, title, titleEm, paragraphs = [], bullets = [], image, imageAlt, reverse = false, testId = "split-section" }) {
  return (
    <section data-testid={testId} className="py-24 lg:py-32 bg-powder/50 border-y border-navy/10">
      <div className={`max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-14 lg:gap-20 items-center ${reverse ? "lg:[&>*:first-child]:order-2" : ""}`}>
        <Reveal>
          <div className="overflow-hidden rounded-t-[100px] rounded-b-xl h-[380px] lg:h-[520px] shadow-[0_24px_50px_rgba(62,74,46,0.14)]">
            <img src={image} alt={imageAlt} className="w-full h-full object-cover" />
          </div>
        </Reveal>
        <div>
          <SectionHeader overline={overline} title={<>{title} {titleEm && <em className="italic font-medium">{titleEm}</em>}</>} />
          <Reveal delay={0.1}>
            <div className="mt-8 space-y-5">
              {paragraphs.map((p) => (
                <p key={p.slice(0, 40)} className="text-base leading-relaxed text-charcoal/80">{p}</p>
              ))}
            </div>
            {bullets.length > 0 && (
              <ul className="mt-8 grid sm:grid-cols-2 gap-x-8 gap-y-4">
                {bullets.map((b) => (
                  <li key={b} className="flex items-start gap-3 text-sm text-charcoal/85">
                    <span className="mt-0.5 grid place-items-center w-5 h-5 rounded-full bg-navy text-ivory shrink-0">
                      <Check size={11} strokeWidth={2.5} />
                    </span>
                    {b}
                  </li>
                ))}
              </ul>
            )}
          </Reveal>
        </div>
      </div>
    </section>
  );
}
